import { downloadNewsAttachment, getNews, getNewsList, translateNews, removeNewsAttachment, saveNewsAttachment, saveNews, deleteNews } from './news.admin.api';
import { getEvents, getEvent, saveEvent, getEnrollments, deleteEvent, saveEventAttachment } from './events.admin.api';
import { getPolls, getPoll, savePoll, deletePoll, getAnswers } from './polls.admin.api';
import { getSurveysList, getSurvey, saveSurvey, deleteSurvey, getSurveySubmissionsAnalytics, getSurveySubmissions, copySurvey, exportSurveySubmissions } from './surveys.admin.api';
import { getResources, getResource, deleteResource, download as downloadResource, saveResource, getResourceFolders, getResourceFolder, deleteResourceFolder, saveResourceFolder } from './resources.admin.api';
import { getFaqList, getFaq, saveFaq, deleteFaq, sort as sortFaq } from './faq.admin.api';
import { getPageCategories, getPageCategory, savePageCategory, sortPageCategories, deletePageCategory, getPages, getPage, getPageGroups, deletePage, sort as sortPages, sortPageAttachments, savePage, savePageAttachment, downloadPageAttachment, removePageAttachment } from './pages.admin.api';
import { getBenefits, getBenefit, saveBenefit, deleteBenefit, sort as sortBenefits } from './benefits.admin.api';
import { getChannels, getChannel, saveChannel } from './chat.admin.api';
import { getFeedbacks, getFeedbacksV2, saveFeedbackMessage, getFeedback, updateFeedback, getFeedbackCount, downloadLegacyFeedbackAttachment, downloadFeedbackAttachment, getFeedbackManagerLog, getFeedbackManagers, addFeedbackManager, updateFeedbackManager, removeFeedbackManager, getFeedbackCategories, getFeedbackCategory, saveFeedbackCategory, getFeedbackPerCategoryWeeklyReport, exportFeedbackCategorySubmissions } from './feedback.admin.api';
import { searchUsers, getTenantAdmins, getAllAdmins, getUser, getUsers, getNewUsers, getNotLoggedInUsers, getUserAdminGroups, getUserGroups, importUser, removeUser, saveUser, removeUserImage, updateUserImage, inviteUser, listMainUsers, promoteMainUser, demoteMainUser, getMainUserLog } from './users.admin.api';
import { getGroups, getGroup, saveGroup, getGroupMembers, getGroupAdmins } from './groups.admin.api';
import { getFeedbackPolicy, saveFeedbackPolicy } from './settings.admin.api';
import { getChangelog } from './changelog.admin.api';
import { uploadImage } from './upload.admin.api';
import { getWallpapers, saveWallpaper, deleteWallpaper, sortWallpapers } from './wallpapers.admin.api';
import { translateText } from './translate.admin.api';
import { deleteDepartment, getDepartment, getDepartments, saveDepartment, } from './departments.admin.api';
import { getTags, getTag, createTag, updateTag, deleteTag, getNewsTags, updateTagsSettings } from './tags.admin.api';
import { getPageAcknowledgmentDetails, getAcknowledments, deleteAcknowledgment, getPageAcknowledgmentOverview, getResourceAcknowledgmentOverview, getAcknowledgments } from './acknowledgments.admin.api';
import { getDefaultNewsImage, saveDefaultNewsImage, deleteDefaultNewsImage } from './news-image.admin.api.js';
import { updateTenantLogo } from './tenant-logo.admin.api.js';
import { updateTenantColor } from './tenant-color.admin.api.js';
import { saveInfoTvScreenWeather, deleteInfoTvScreenWeather, getInfoTvScreenWeather, getInfoTvScreenSettings, updateInfoTvScreenSettings, getInfoTvContents, saveInfoTvImage, sortInfoTvScreenContent, deleteInfoTvImage, getInfoTvImage, getInfoTvScreenContent, deleteInfoTvScreenContent, getInfoTvScreens, saveInfoTvScreenContent, uploadAndAddImage, getInfoTvFooterTexts, saveInfoTvFooterText, deleteInfoTvFooterText, sortInfoTvFooterTexts, getInfoTvNewsPreview } from './infotv.admin.ap';

const adminApi = {

    // InfoTv
    saveInfoTvScreenWeather,
    deleteInfoTvScreenWeather,
    getInfoTvScreenWeather,
    getInfoTvScreenSettings,
    updateInfoTvScreenSettings,
    getInfoTvContents,
    saveInfoTvImage,
    getInfoTvScreens,
    getInfoTvScreenContent,
    saveInfoTvScreenContent,
    deleteInfoTvScreenContent,
    sortInfoTvScreenContent,
    uploadAndAddImage,
    deleteInfoTvImage,
    getInfoTvImage,
    getInfoTvFooterTexts,
    saveInfoTvFooterText,
    deleteInfoTvFooterText,
    sortInfoTvFooterTexts, getInfoTvNewsPreview,
    getInfoTvNewsPreview,

    // Default news image
    getDefaultNewsImage,
    saveDefaultNewsImage,
    deleteDefaultNewsImage,

    // Tenant logo
    updateTenantLogo,

    // Tenant color
    updateTenantColor,

    // Departments
    deleteDepartment,
    getDepartment,
    getDepartments,
    saveDepartment,

    // Translate
    translateText,

    // News
    downloadNewsAttachment,
    getNews,
    getNewsList,
    removeNewsAttachment,
    saveNewsAttachment,
    saveNews,
    deleteNews,

    // Events
    getEvents,
    getEvent,
    saveEvent,
    getEnrollments,
    deleteEvent,
    saveEventAttachment,

    // Polls
    getPolls,
    getPoll,
    savePoll,
    deletePoll,
    getAnswers,

    // Surveys
    getSurveysList,
    getSurvey,
    saveSurvey,
    deleteSurvey,
    getSurveySubmissionsAnalytics,
    getSurveySubmissions,
    copySurvey,
    exportSurveySubmissions,

    // Resources
    getResources,
    getResource,
    deleteResource,
    downloadResource,
    saveResource,
    getResourceFolder,
    getResourceFolders,
    deleteResourceFolder,
    saveResourceFolder,

    // Faq
    getFaqList,
    getFaq,
    saveFaq,
    deleteFaq,
    sortFaq,

    // Page Categories
    getPageCategories,
    getPageCategory,
    savePageCategory,
    sortPageCategories,
    deletePageCategory,

    // Pages
    getPages,
    getPage,
    getPageGroups,
    savePage,
    savePageAttachment,
    sortPageAttachments,
    deletePage,
    sortPages,
    downloadPageAttachment,
    removePageAttachment,

    getWallpapers,
    saveWallpaper,
    deleteWallpaper,
    sortWallpapers,

    // Benefits
    getBenefits,
    getBenefit,
    saveBenefit,
    deleteBenefit,
    sortBenefits,

    // Feedback
    getFeedbacks,
    getFeedbacksV2,
    getFeedback,
    updateFeedback,
    getFeedbackCount,
    downloadLegacyFeedbackAttachment,
    downloadFeedbackAttachment,
    getFeedbackManagers,
    getFeedbackManagerLog,
    addFeedbackManager,
    updateFeedbackManager,
    removeFeedbackManager,
    saveFeedbackMessage,
    getFeedbackCategories,
    getFeedbackCategory,
    saveFeedbackCategory,
    getFeedbackPerCategoryWeeklyReport,
    exportFeedbackCategorySubmissions,

    // Chat
    getChannels,
    getChannel,
    saveChannel,

    // Users
    getUsers,
    getNewUsers,
    getNotLoggedInUsers,
    searchUsers,
    getUserAdminGroups,
    getUserGroups,
    getUser,
    saveUser,
    updateUserImage,
    removeUserImage,
    getTenantAdmins,
    getAllAdmins,
    removeUser,
    importUser,
    inviteUser,
    listMainUsers,
    promoteMainUser,
    demoteMainUser,
    getMainUserLog,


    // Groups
    getGroups,
    getGroup,
    saveGroup,
    getGroupMembers,
    getGroupAdmins,

    // Tags
    getTags,
    getTag,
    createTag,
    updateTag,
    deleteTag,
    getNewsTags,
    updateTagsSettings,

    // Settings
    getFeedbackPolicy,
    saveFeedbackPolicy,

    // Upload
    uploadImage,

    // Changelog
    getChangelog,

    // Acknowledgments
    getPageAcknowledgmentDetails,
    getAcknowledments,
    deleteAcknowledgment,
    getPageAcknowledgmentOverview,
    getResourceAcknowledgmentOverview,
    getAcknowledgments,
};

export default adminApi;
